import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenSelect", "buttonText", "menu", "otherWrapper", "otherInput"] // merge with any existing ones

  connect() {
    this.updateButtonText()
    this.boundCloseOthers = this.closeOthers.bind(this)
    window.addEventListener('multiselect:opened', this.boundCloseOthers)
  }

  disconnect() {
    window.removeEventListener('multiselect:opened', this.boundCloseOthers)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation() 
    
    const isOpening = this.menuTarget.classList.contains("hidden")
    
    if (isOpening) {
      window.dispatchEvent(new CustomEvent('multiselect:opened', { detail: { current: this.element } }))
    }
    
    this.menuTarget.classList.toggle("hidden")

    if (isOpening && this.hasSearchInputTarget) {
      setTimeout(() => this.searchInputTarget.focus(), 50)
    }
  }

  toggleOtherField(event) {
    const el = event.currentTarget
    if (el.dataset.isOther !== "true") return
  
    const option = this.hiddenSelectTarget.querySelector(`option[value="${el.dataset.value}"]`)
    const isSelected = option?.selected
  
    if (!this.hasOtherWrapperTarget) return
    this.otherWrapperTarget.classList.toggle("hidden", !isSelected)
  
    if (this.hasOtherInputTarget) {
      this.otherInputTarget.disabled = !isSelected
      if (!isSelected) this.otherInputTarget.value = ""
    }
  }

  closeOthers(event) {
    if (event.detail.current !== this.element) {
      this.menuTarget.classList.add("hidden")
    }
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  filter(event) {
    const searchTerm = event.target.value.toLowerCase()
    
    this.optionTargets.forEach(option => {
      const text = option.textContent.toLowerCase()
      if (text.includes(searchTerm)) {
        option.classList.remove('hidden')
      } else {
        option.classList.add('hidden')
      }
    })
  }

  selectOption(event) {
    event.stopPropagation() 
    
    const item = event.currentTarget
    const value = item.dataset.value
    const isMultiple = this.hiddenSelectTarget.multiple
    
    const activeClass = item.dataset.activeClass || "bg-brand-25"
    const hoverClass = item.dataset.hoverClass || "hover:bg-brand-50"
    
    const nativeOption = Array.from(this.hiddenSelectTarget.options).find(opt => opt.value === value)

    if (nativeOption) {
      if (!isMultiple) {
        Array.from(this.hiddenSelectTarget.options).forEach(opt => opt.selected = false)
        this.element.querySelectorAll('.option-wrapper').forEach(wrapper => {
          wrapper.classList.remove(activeClass)
          wrapper.classList.add(hoverClass)
        })
        this.element.querySelectorAll('.checkmark-icon').forEach(icon => {
          if (icon) icon.classList.add("hidden")
        })
        this.menuTarget.classList.add("hidden");
      }

      nativeOption.selected = isMultiple ? !nativeOption.selected : true
      
      const wrapper = item.querySelector('.option-wrapper')
      const checkmark = item.querySelector('.checkmark-icon')

      if (nativeOption.selected) {
        wrapper.classList.add(activeClass)
        wrapper.classList.remove(hoverClass)
        if (checkmark) checkmark.classList.remove("hidden")
      } else {
        wrapper.classList.remove(activeClass)
        wrapper.classList.add(hoverClass)
        if (checkmark) checkmark.classList.add("hidden")
      }

      this.updateButtonText()
    }
  }
  
  toggleAccordion(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const header = event.currentTarget
    const content = header.nextElementSibling 
    
    content.classList.toggle('hidden')
    content.classList.toggle('flex')
    
    if (header) header.classList.toggle('active-main-option')
  }

  updateButtonText() {
    const selectedOptions = Array.from(this.hiddenSelectTarget.selectedOptions).filter(opt => opt.value !== "")
    
    if (selectedOptions.length === 0) {
      this.buttonTextTarget.textContent = this.element.dataset.placeholder || "Select"
    } else if (selectedOptions.length === 1) {
      this.buttonTextTarget.textContent = selectedOptions[0].text
    } else {
      this.buttonTextTarget.textContent = `${selectedOptions.length} selected`
    }
  }
}